import { Dialog } from "primereact/dialog"
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { JVInput } from "../../shared/JVInput";
import { Button } from "primereact/button";
import { Fetch } from "../../shared/Fetch";
import { IEmailTempDropdown } from "../../models/IDropdown";
import { Dropdown } from "primereact/dropdown";
import { IEmailTemplate } from "../../models/EmailTemplate";
import { Checkbox } from "primereact/checkbox";
import { ISignatureMast } from "../../models/SignatureMast";

interface IProps {
    tableData: any[],
    openSendEmail: boolean,
    closeSendEmailModal: () => void,
    toast: any
}

interface ISendEmailForPaymentUpdate {
    senderEmail?: string | null;
    subject?: string | null;
    body?: string | null;
}

const schema = yup.object({
    // senderEmail: yup.string().required("Sender Email is required"),
    subject: yup.string().nullable(),
    body: yup.string().nullable(),
});

const demoTemplates = [
    {
        subject: `Reminder: INActive POC`,
        body: `
      <div class="editor-note" style="color: red; margin-bottom: 0.5rem;">
        <strong>Note:</strong> Do not remove or edit <code>@POC_Name</code>. It will be automatically replaced with the contact person's name when sending the email.
      </div>
      <p>Dear @POC_Name,</p>
      <br/>
      You are inactive in POC. Please follow up at your earliest convenience.<br/><br/>
      Regards,<br/>
      <p>Best regards,</p>
      @signator
    `
    }
];


export const SendEmailForPaymentUpdate = (props: IProps) => {
    const [emailDescription, setEmailDescription] = useState("");
    const [emailTemplates, setEmailTemplates] = useState([] as { subject: string, body: string }[]);
    const [emailTemplatesData, setEmailTemplatesData] = useState<Array<IEmailTempDropdown>>();
    const [etId, setEtId] = useState(0);
    const [body, setBody] = useState("");
    const [signature, setSignature] = useState({ val: "", disabled: true });
    const [signatureDetails, setSignatureDetails] = useState<ISignatureMast>({});
    const [emailTemplateIndex, setEmailTemplateIndex] = useState<number>(1);
    const [loading, setLoading] = useState(false);
    const { control, handleSubmit, formState: { errors }, reset, watch, setValue, setError, setFocus } = useForm<ISendEmailForPaymentUpdate>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false
    });

    const onSubmit = async (fbody: ISendEmailForPaymentUpdate) => {

        if (body.length < 1) {
            props.toast.current.show({ severity: 'error', detail: "Choose Template First.", life: 3000 });
        } else {
            setLoading(true);
            const newEmailSendingBody = { ...fbody, subject: fbody.subject, signature: signature.val, body: body, followup_ID: props.tableData.map(item => item.followup_ID) };
            console.log(newEmailSendingBody)
            const response = await Fetch("InActivePrimeVendor/sendEmailUpdate", "POST", newEmailSendingBody, null, props.toast);
            if (response) {
                props.toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Email sent successfully!', life: 3000 });
                onHide();
            }
            setLoading(false);
        }
    };

    const loadSignature = async () => {
        const response = await Fetch("Signature_Mast", "GET", null, null, null);
        if (response) {
            const data: ISignatureMast = await response.json();
            setSignatureDetails(data);
            if (data.signature) setSignature({ val: data.signature, disabled: signature.disabled });
        }
    }

    const loadEmailTemplate = async () => {
        setEmailTemplates(prev => prev = demoTemplates);
        setValue("subject", emailTemplates[0].subject);
        setEmailDescription(emailTemplates[0].body);
    };

    const onClear = () => {
        reset();
        setLoading(false);
        setEmailTemplateIndex(0);
        setEmailDescription("");
        setValue("senderEmail", null);
        setValue("subject", null);
        setValue("body", null);
    }

    const onHide = () => {
        setEmailDescription("");
        setEmailTemplateIndex(0);
        onClear();
        setLoading(false);
        props.closeSendEmailModal();
        reset({ subject: "" }); setBody(""); setEtId(0);

    };

    useEffect(() => {
        if (emailTemplates.length > 0 && props.openSendEmail) {
            setEmailTemplateIndex(0);
            setValue("subject", emailTemplates[0].subject);
            setEmailDescription(emailTemplates[0].body);
        }
    }, [emailTemplates]);

    const loadEmailTemplates = async () => {
        const response = await Fetch("DropDown/emailTemplateofFollowup", "GET", null, null, null);
        if (response) {
            const data: Array<IEmailTempDropdown> = await response.json();
            setEmailTemplatesData(data);
        }
    }

    const fillEmailTemplate = async () => {
        const response = await Fetch("Email_Template/byId", "GET", null, `id=${etId}`, null);
        if (response) {
            const data: IEmailTemplate = await response.json();
            if (data.template_Subject) setValue("subject", data.template_Subject);
            if (data.template_Body) setBody(data.template_Body);
        }
    }



    useEffect(() => {
        if (props.openSendEmail) {
            loadEmailTemplate();
            loadSignature();

            loadEmailTemplates();
        }
    }, [props.openSendEmail]);

    useEffect(() => {
        if (etId) fillEmailTemplate();
    }, [etId]);



    return (
        <>
            <Dialog style={{ width: '70vw' }} visible={props.openSendEmail} onHide={() => onHide()} header="Send Emai For Follow-Up" >
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-6">
                        <Dropdown options={emailTemplatesData} optionValue={"template_Id"} optionLabel={"template_Name"} value={etId} onChange={e => setEtId(e.value)} placeholder="Choose Email Template" />
                    </div>
                    <JVInput column={1} label="Subject" control={control} name="subject" error={errors.subject?.message} />
                    <div className="col-12 md:col-12 md:col-6 mb-3">
                        <div>
                            <p>Note:</p> Do not remove or edit @POC_Name. It will be automatically replaced with the contact person's name when sending the email.
                        </div>
                        <label>Body</label>
                        <CKEditor editor={ClassicEditor} data={body} onChange={(event, editor) => { setBody(editor.getData()); }} />
                    </div>
                    <div className="col-12 md:col-12 md:col-6">
                        <div style={{ display: 'flex', justifyContent: "space-between", alignItems: "flex-end" }}>
                            <label>Signature</label>
                            <div className="field-checkbox m-1">
                                {/* {signature.disabled ? <Button type="button" icon="pi pi-pencil" className="p-button-rounded p-button-text" onClick={() => setSignature({ val: signature.val, disabled: false })} /> */}
                                {/* : <Button type="button" icon="pi pi-ban" className="p-button-rounded p-button-text" onClick={() => setSignature({ val: signature.val, disabled: true })} />} */}
                                {/* <label className="mr-1" htmlFor="binary">Short Sign</label> */}
                                {/* <Checkbox inputId="binary" checked={isShort} onChange={e => setIsShort(e.checked)} /> */}
                            </div>
                        </div>
                        <CKEditor editor={ClassicEditor} data={signature.val} onChange={(event, editor) => { setSignature({ val: editor.getData(), disabled: signature.disabled }); }} disabled={signature.disabled} />
                    </div>
                    <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                        <Button loading={loading} disabled={loading} label="SEND" type={loading === false ? "submit" : "button"} style={{ width: '100px' }} ></Button>
                        <Button className="p-button-outlined surface-200" style={{ width: '100px' }} label="CLEAR" onClick={onClear} type="button" ></Button>
                    </div>
                </form>
            </Dialog >
        </>
    )
}